var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9 163.8C127.132 163.8 163.8 127.132 163.8 81.9C163.8 36.6679 127.132 0 81.9 0C36.6679 0 0 36.6679 0 81.9C0 127.132 36.6679 163.8 81.9 163.8Z",
    fill: "#99CC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.085 81.5979L45 45.8811L62.9889 82.2915L45.7809 119.177L128.085 81.5979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.9,
    height: 163.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.1a1508961acf8c23cf5309673713e93e.svg";
export { ForwardRef as ReactComponent };